"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = UIApplication;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _setupStyledComponents = require("../listeners/setupStyledComponents");

var _ComponentWithBodyClass = _interopRequireDefault(require("../utils/ComponentWithBodyClass"));

function UIApplication(props) {
  var _bodyElement = props._bodyElement,
      bodyClassName = props.bodyClassName,
      name = props.name,
      rest = (0, _objectWithoutProperties2.default)(props, ["_bodyElement", "bodyClassName", "name"]);
  (0, _react.useEffect)(_setupStyledComponents.setupStyledComponents, []);
  return _react.default.createElement(_ComponentWithBodyClass.default, {
    bodyClassName: (0, _classnames.default)('ui-app', bodyClassName),
    bodyElement: _bodyElement
  }, _react.default.createElement("div", (0, _extends2.default)({
    "data-application-name": name
  }, rest)));
}

UIApplication.propTypes = {
  _bodyElement: _propTypes.default.object,
  bodyClassName: _propTypes.default.string,
  name: _propTypes.default.string.isRequired
};
UIApplication.displayName = 'UIApplication';
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/UIComponents/static-2.3729/js/app/UIApplication.js
// module id = 600
// module chunks = 209 210 211 212